var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Button_Container"},[_c('button',{class:['Button_Btn', { inactive: !_vm.active }],style:({
      'border-radius': _vm.radius ? '30px' : 'none',
      'background-color': _vm.outline ? _vm.reverseColor : _vm.color,
      color: _vm.outline ? _vm.color : _vm.reverseColor,
      border: ("1px solid " + _vm.color)
    }),on:{"click":function($event){_vm.active ? _vm.$emit('clickButton') : null}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }